import { TABLE_BOOK_GALLERY_REQUEST, TABLE_BOOK_GALLERY_SUCCESS, TABLE_BOOK_GALLERY_FAILURE } from '../../actions/types';

// reducer.js
const initialState = {
    isLoading: false,
    response: null,
    error: null
};
  
export const tableGalleryBookReducer = (state = initialState, action) => {
    switch (action.type) {
        case TABLE_BOOK_GALLERY_REQUEST:
            return { ...state, isLoading: true, response: null, error: null };
        case TABLE_BOOK_GALLERY_SUCCESS:
          // alert(JSON.stringify(action))
            return { ...state, isLoading: false, response: action.payload, error: null };
        case TABLE_BOOK_GALLERY_FAILURE:
            return { ...state, isLoading: false, response: null, error: action.payload };
        default:
            return state;
    }
};
  
  